import { $ } from 'src/shared/js/utils/dom';

export const $uberallLocations = $('#uberall-locations');

export const mapboxAccessToken = process.env.THREE_PAC_MAPBOX_ACCESS_TOKEN || '';

export const defaultLocationsUrl = '/locations.json';
